












































































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import {
  RedCapital,
  SelectedCountry,
  Configuration,
  TitleTemplatePublic
} from "@/configuration";
//import GReCaptcha from "@/components/GReCaptcha.vue";
import API from "@/api";
import { EventBus } from "@/main";
import { isUserLogin } from "@/utils";
// @ts-ignore
import InvisibleRecaptcha from 'vue-invisible-recaptcha';
//@ts-ignore
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
// // @ts-ignore
// import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
// Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)

@Component({
  metaInfo: {
    title: "RedCapital  | Plataforma de Financiamiento Digital ",
    //titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      token:'',
      loading:true,
      origen_reclamo:4,
      dato_adicional:'',
      clasificacion:'',
      clasificacion_id: "",
      clasificaciones:[],
      valid: true,
      name: "",
      email: "",
      phone:"",
      message: "",
      canPress: true,
      dialog: false,
      errorMessage: null,
      captcha: false,
      nameRules: [
        (v: any) => !!v || "Ingrese nombre",
        (v: any) =>
          v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
      ],
      emailRules: [
        (v: any) => !!v || "Ingrese correo electrónico",
        (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
      ],
      messageRules: [
        (v: any) => !!v || "Ingrese mensaje",
        (v: any) =>
          v.length >= 5 || "El mensaje debe tener al menos 5 caracteres."
      ],
      rulephone: [
        (v: any) => !!v || 'Teléfono es requerido',
        (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros",
        (v: any) => v.length > 7 || "Minimo 8 caracteres",
        (v: any) => !!v || "Ingrese un valor"
      ],
    };
  },
  beforeMount() {
     
    isUserLogin(() => {
      this.$data.name = `${this.$store.state.user.nombre} ${this.$store.state.user.app_pat}`;
      this.$data.email = this.$store.state.user.email;
    });

    API.listar_clasificaciones()
    .then((res: any)=>{
      this.$data.clasificaciones = res
    })
  },
  watch: {
    clasificacion(v){
        this.$data.clasificacion_id = v.id;
    },

  },
  methods: {
    validate() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        this.$data.token = token
        //@ts-ignore
        this.validatefrom(token)
      }else{
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
       // alert('please check you are not robot');
        this.$data.canPress = true;
        this.$data.errorMessage = "Error";
      }
    },
    async validatefrom(token) {
      this.$data.canPress = false;

      // @ts-ignore
      if (this.$refs.form.validate()) {
        API.contact(token,this.$data.name, this.$data.email, this.$data.phone, this.$data.message, this.$data.clasificacion_id, this.$data.dato_adicional,this.$data.origen_reclamo)
          .then((data: any) => {
            this.$data.dialog = true;
            setTimeout(() => {
               this.$data.dialog = false;
              this.$router.push({
                path: "/"
              });
            }, Configuration.Redirection.timeout);
          })
          .catch(res => {
            this.$data.canPress = true;
            this.$data.errorMessage = "Error";
            if (res.message.nombre != null) {
              EventBus.$emit("snack-error", res.message.nombre[0]);
            }
            if (res.message.mail != null) {
              EventBus.$emit("snack-error", res.message.mail[0]);
            }
            if (res.message.mensaje != null) {
              EventBus.$emit("snack-error", res.message.mensaje[0]);
            }
          });
      }
    },
    doRecaptcha() {
      // @ts-ignore
      this.$refs.recaptchaContact.execute();
    }
  },
  components: {
   // GReCaptcha,
  //  "invisible-recaptcha": InvisibleRecaptcha
    gRecaptcha
  }
})
export default class Contact extends Vue {}
